import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import RadioCard from '@/components/Form/RadioCard';

// STYLES
import { TitleContainer, Title } from '../styles';

const getSubStepName = (values, showDeviceContractStep) => {
  if (values.device_included === 'yes' && showDeviceContractStep) {
    return 'agree_device_contract';
  }

  return 'device_included';
};

const getVariants = stepName => {
  if (stepName === 'agree_device_contract') {
    return [
      { text: 'start.agree_device_contract.variants.yes', value: 'yes' },
      { text: 'start.agree_device_contract.variants.no', value: 'no' },
    ];
  }

  return [
    { text: 'start.device_included.variants.yes', value: 'yes' },
    { text: 'start.device_included.variants.no', value: 'no' },
    { text: 'start.device_included.variants.notSure', value: 'not_sure' },
  ];
};

const DeviceIncluded = ({
  values,
  handleChange,
  handleBlur,
  onRadioCardChange,
  isRequired,
  showDeviceContractStep,
}) => {
  const [t] = useTranslation();
  const subStepName = getSubStepName(values, showDeviceContractStep);
  const variants = getVariants(subStepName);

  const handleAnswerClick = event => {
    onRadioCardChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {t(`start.${subStepName}.title`)}
        </Title>
        <Typography variant="subtitle1" align="center">
          {t(`start.${subStepName}.subtitle`)}
        </Typography>
      </TitleContainer>
      <Grid container spacing={1} justifyContent="center">
        {variants.map(item => (
          <Grid item xs={6} sm={6} md={3} key={item.value}>
            <RadioCard
              name={subStepName}
              text={t(item.text)}
              handleChange={handleAnswerClick}
              handleBlur={handleBlur}
              value={item.value}
              checkedValue={values[subStepName]}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

DeviceIncluded.defaultPros = {
  isRequired: false,
};

DeviceIncluded.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onRadioCardChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  showDeviceContractStep: PropTypes.bool.isRequired,
};

export default React.memo(DeviceIncluded);
